// Módulo para obtener suprazones
/* eslint-disable */
import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_API + '/excursion/activity-groups/'

const state = {
  groups: [],
  groupsListAdmin: [],
}

const actions = {

  async loadGroups({
    commit
  }) {
    await axios
      .get(baseUrl)
      .then(r => r.data)
      .then(groups => {
        commit('SET_GROUPS', groups)
      })
  },

  async loadGroupsBySuprazone({
    commit
  }, data) {
    if (data == null || data.suprazone_id == null) 
      return

    return axios
      .get(
        baseUrl + 'list_by_suprazone/' + '?suprazone_id=' + data.suprazone_id
      )
      .then(response => {
        commit('SET_GROPS_LIST_ADMIN', response.data)
        return response.data
      })
  },

  async createActivityGroup({
    commit, dispatch
  }, data) {
    await axios
      .post(baseUrl, data.payload)
      .then( response => {
        dispatch('loadGroupsBySuprazone', data)
        return response.data
      })
  },

  async updateActivityGroup({
    commit, dispatch
  }, data) {

    await axios
      .patch(baseUrl + data.activity_group_id + '/', data.payload)
      .then(response => {
        dispatch('loadGroupsBySuprazone', data)
        return response.data
      })
  },

  async deleteActivityGroup({
    commit, dispatch
  }, data) {
    if ( data.force_delete == null) {
      data.force_delete = 0
    }
    return axios
      .delete(
        baseUrl + data.activity_group_id + '/' + 
        '?force_delete=' + data.force_delete
      )
      
  }

}

const mutations = {

  SET_GROUPS(state, groups) {
    state.groups = groups
  },
  SET_GROPS_LIST_ADMIN(state, groups) {
    state.groupsListAdmin = groups
  },
  RESET_GROUPS_LIST_ADMIN(state) {
    state.groupsListAdmin = []
  },
  PROPOSE_ACTIVITY_GROUP_ORPHAN_BOOKINGS(state) {
    
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
